import { Autocomplete, Grid, IconButton, InputAdornment, TextField, Tooltip } from "@mui/material";
import Iconify from "../../minimals/components/iconify";
import { RecordableType } from "./types";
import { Dispatch, SetStateAction, useState } from "react";

interface IProps {
  options: RecordableType[];
  setSelectedRecordableType: Dispatch<SetStateAction<RecordableType | null>>;
  copyToClipboard: Function;
  disabled?: boolean;
  disableReorder?: boolean;
  isReorderMode: boolean;
  onToggleReorderMode: () => void;
}

export default function RecordableFilters({
  options,
  setSelectedRecordableType,
  copyToClipboard,
  disabled = false,
  disableReorder = false,
  isReorderMode,
  onToggleReorderMode
}: IProps) {
  const [showFilters, setShowFilters] = useState<boolean>(false);

  const toggleShowFilters = () => setShowFilters(!showFilters);

  return (
    <Grid container spacing={2} padding={showFilters ? 3 : 1} alignItems="center">
      {showFilters && (
        <>
          <Grid item xs={8}>
            <TextField
              fullWidth
              disabled={disabled}
              sx={{ maxWidth: 705 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Iconify icon="eva:search-fill" />
                  </InputAdornment>
                )
              }}
              placeholder="Search Recordables..."
            />
          </Grid>
          <Grid item xs={2.5}>
            <Autocomplete
              disabled={disabled}
              renderInput={(params) => <TextField {...params} label="Document Type" />}
              options={options}
              getOptionLabel={(o) => o.description}
              onChange={(_, value) => setSelectedRecordableType(value)}
            />
          </Grid>
        </>
      )}
      <Grid item xs={showFilters ? 1.5 : 12} textAlign="right">
        <Tooltip title={showFilters ? "Hide filters" : "Show filters"}>
          <IconButton onClick={toggleShowFilters}>
            <Iconify icon={showFilters ? "ic:outline-filter-list" : "ic:outline-filter-list-off"} />
          </IconButton>
        </Tooltip>
        <Tooltip title={isReorderMode ? "Exit reorder mode" : "Re-order documents"}>
          <span>
            <IconButton
              onClick={onToggleReorderMode}
              disabled={disableReorder}
              color={isReorderMode ? "success" : "default"}
            >
              <Iconify icon={isReorderMode ? "eva:checkmark-fill" : "mdi:drag"} />
            </IconButton>
          </span>
        </Tooltip>
        <Tooltip title="Copy recordable summary">
          <span>
            <IconButton onClick={() => copyToClipboard()} disabled={disabled}>
              <Iconify icon="codicon:combine" />
            </IconButton>
          </span>
        </Tooltip>
      </Grid>
    </Grid>
  );
}
